import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { Modal, Row, Col, Typography } from 'antd';

import StorageBinList01Actions from '../../Stores/StorageBinList01/Actions';

const QRCode = require('qrcode.react');

const { Text } = Typography;

class BarcodeDialog extends React.PureComponent {
  constructor() {
    super();

    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    const { setDialogVisible } = this.props;

    setDialogVisible(false);
  }

  render() {
    const { intl, dialogIsVisible, barcode, code, desc01, desc02 } = this.props;

    return (
      <>
        <Modal
          visible={dialogIsVisible}
          title={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <Text>{`${code}`}</Text>
          }
          // style={{top:20}}
          width="50%"
          centered
          // onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
          className="pick-list-dialog"
        >
          <Row type="flex">
            <Col span={20} style={{ margin: 'auto' }}>
              <DialogRow
                header={<Text>{intl.formatMessage({ id: 'barcode' })}</Text>}
                details={<QRCode value={barcode} size={200} />}
              />
              <DialogRow
                header={<Text>{intl.formatMessage({ id: 'description' })}</Text>}
                details={<Text>{`${desc01} ${desc02}`}</Text>}
              />
            </Col>
          </Row>
        </Modal>
      </>
    );
  }
}

function DialogRow(props) {
  // eslint-disable-next-line react/prop-types
  const { className, header, details } = props;
  return (
    <Row type="flex" gutter={[8, 8]} className={className || 'modalinfo-row'}>
      <Col span={5} className="modalinfo">
        {header}
      </Col>
      <Col span={19} className="modalinfo-details">
        {details}
      </Col>
    </Row>
  );
}

BarcodeDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  setDialogVisible: PropTypes.func,
  dialogIsVisible: PropTypes.bool,
  barcode: PropTypes.string,
  code: PropTypes.string,
  desc01: PropTypes.string,
  desc02: PropTypes.string
};

BarcodeDialog.defaultProps = {
  intl: {},
  setDialogVisible() {},
  dialogIsVisible: false,
  barcode: '',
  code: '',
  desc01: '',
  desc02: ''
};

const mapStateToProps = state => ({
  dialogIsVisible: state.storageBinList01.barcodeDialogIsVisible,
  barcode: state.storageBinList01.barcodeDialogBarcode,
  code: state.storageBinList01.barcodeDialogCode,
  desc01: state.storageBinList01.barcodeDialogDesc01,
  desc02: state.storageBinList01.barcodeDialogDesc02
});

const mapDispatchToProps = dispatch => ({
  setDialogVisible: boolean =>
    dispatch(StorageBinList01Actions.storageBinList01SetBarcodeVisible(boolean))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BarcodeDialog));
